<template>
    <BorrarModalComponent
        :name="'borrar-' + liquidacion.id"
        title="Borrar liquidación"
        confirmButton="¿BORRAR  LIQUIDACIÓN?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarLiquidacion()"
    />
</template>

<script>
    import BorrarModalComponent from "../../../../components/backend/components/BorrarModalComponent";

    export default {
        props: ['liquidacion'],
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.liquidacion.id, borrado);
            },
            borrarLiquidacion() {
                const params = {
                    filters : {},
                    liquidacion_id: this.liquidacion.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.bases.delete'), params).then(res => {
                    this.$toast.success("Liquidación borrada correctamente");
                    this.close(true);
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
